import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.strong(props => ({
    color: theme(props).typography.primary.color,
}));
